import { Nullable } from '@clearverify/types';

import { PermissiblePurposeStatus, PermissiblePurposeWhere } from 'src/api';

export const buildPermissiblePurposesFilter = (
  verifierId: Nullable<string>,
): PermissiblePurposeWhere => {
  if (!verifierId) return {};

  return {
    status: {
      equals: PermissiblePurposeStatus.Approved,
    },
    verifierId: { equals: verifierId },
  };
};
